// src/pb.js
import PocketBase from 'pocketbase';

// use the public tunnel hostname
const pb = new PocketBase('https://api.fridgelist.app');

pb.autoCancellation(false);
export default pb;